// NATIVE 
import { useEffect, useState } from 'react'


// INSTALLED 
import { Link } from 'react-router-dom';
import { Button, Divider } from '@mui/material';


// CUSTOM 
import { mtDividerUpTable } from '../../commons';
import { hasPemissions } from '../../commons/utils';
import { TableEmpleados } from '../../components/tables';
import { SnackAlert } from '../../components/SnackAlert';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';





/**
 * Employees component renders the employee listing page.
 * 
 * This component handles the following functionalities:
 * - Checks if the user has permission to create a new employee.
 * - Displays a snackbar alert for notifications.
 * - Renders breadcrumbs and title for navigation.
 * - Conditionally renders a button to create a new employee if the user has the required permissions.
 * - Renders a table of employees.
 * 
 * @component
 * @returns {JSX.Element} The Employees component.
 * 
 * @example
 * // Usage example
 * <Employees />
 */
export const Employees = () => {


    const [canCreate, setCanCreate] = useState(false);
  
  
    const [alert_snack, setAlertSnack] = useState(false);
    const [msgSnack, setMsgSnack] = useState({
        msg: '',
        status: 'success'
    });
  
  
    // USE EFECT 
    useEffect(() => {
      canCheckCanCreate();
    }, []);



    const canCheckCanCreate = async () => {
             
      const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'create');

      setCanCreate(havePermissions);

    }



  return (
    <div>
        
        <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>

        <BreadCrumbsAndTitle
                    title="Listado Empleados" 
                    mainModule="Talento Humano" 
                    parent="Listado Empleados"
                    action="" />
        {
          canCreate &&
                <div style={{ display: 'flex', justifyContent: 'end'}}>
                <Button component={Link} to={'/talento-humano/crear-empleado'}  variant='contained' sx={{ marginBottom: 3 }}>Crear Empleado</Button>
                </div>
        }
        
        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.empleado} />
        <Divider sx={{ marginBottom: mtDividerUpTable }}/>
    
        <TableEmpleados />
    </div>
  )
}


